// extracted by mini-css-extract-plugin
export default {"faqContent":"FAQM_faqContent__2yxQn","faqItem":"FAQM_faqItem__Z4QTB","faqQuestion":"FAQM_faqQuestion__iz870","active":"FAQM_active__6P8BV","faqAnswer":"FAQM_faqAnswer__aGB3B"};